<template>
  <el-tooltip
    :content="getContent"
    placement="top"
  >
    <i
      class="label iconfont"
      :class="[getIcon, getStatus]"
    ></i>
  </el-tooltip>

</template>
<script>
import { mediaPlatForm } from "@/common/dictionary";

export default {
  props: {
    tableData: Object,
    scope: Object
  },
  data() {
    return {};
  },
  computed: {
    getIcon: function() {
      return _.find(
        mediaPlatForm,
        item => this.scope.row[this.tableData.bind] == item.value
      ).iconClass;
    },
    getStatus: function() {
      return _.find(
        this.tableData.optionList,
        item => this.scope.row[this.tableData.status] == item.value
      ).iconClass;
    },
    getContent: function() {
      return _.find(
        this.tableData.optionList,
        item => this.scope.row[this.tableData.status] == item.value
      ).label;
    }
  },
  watch: {},
  mounted() {
    this.log();
  },
  methods: {
    log() {}
  }
};
</script>
<style lang="scss" scoped>
.label {
  color: #409eff;
  margin: 0 10px;
  font-size: 24px;
  line-height: 24px;
  &.danger {
    color: #e6a23c;
  }
  &.death {
    color: #f56c6c;
  }
}
</style>
